import { render, staticRenderFns } from "./ConversationSpeechBubble.vue?vue&type=template&id=cf39bff0&scoped=true&"
import script from "./ConversationSpeechBubble.vue?vue&type=script&lang=js&"
export * from "./ConversationSpeechBubble.vue?vue&type=script&lang=js&"
import style0 from "./ConversationSpeechBubble.vue?vue&type=style&index=0&id=cf39bff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf39bff0",
  null
  
)

export default component.exports